import cx from 'classnames'

import { builderLightText } from '@/blocks/utils'
import type { BackgroundColor, Space } from '@/components/Container'
import { HeadingL, BodyM, type TypographyColorModifier } from '@/components/Typography'
import type { TitleProps } from '@/models'

import type { BuilderImage } from '@/models/BuilderImage'

import { Container, MediaWrapper, StyledImage } from './styles'

interface SegregatedContent {
  firstPart: string
  secondPart: string
}

interface MediaWithBackgroundBlockProps {
  id?: string
  title: TitleProps
  segregatedContent?: SegregatedContent
  background?: BackgroundColor
  backgroundColor?: string
  image?: BuilderImage
  space: Space
  colorModifier?: TypographyColorModifier
}

const MediaWithBackgroundBlock = ({
  id,
  title,
  segregatedContent,
  background,
  backgroundColor,
  image,
  space = 'm',
  colorModifier,
}: MediaWithBackgroundBlockProps) => {
  const lightText = builderLightText(colorModifier)
  return (
    <Container
      id={id}
      style={{
        backgroundColor: (background === 'custom' && backgroundColor) || undefined,
      }}
      className={cx({
        [`et-bg-${background}`]: background !== 'custom' && background,
        [`eu-sm-${space}`]: space,
      })}
    >
      <MediaWrapper className="mediaWrapper">
        {(segregatedContent || image || title) && (
          <>
            <div className="mediaText__firstPart">
              <HeadingL light={lightText} tag={title.tag || 'h3'} className="title">
                {title.text}
              </HeadingL>
              {segregatedContent && (
                <BodyM
                  light={lightText}
                  tag="div"
                  html={segregatedContent.firstPart}
                  className="content__firstPart"
                />
              )}
            </div>
            {image && (
              <div className="mediaImage">
                <StyledImage
                  source={image.url}
                  alt={image.alt}
                  width={328}
                  height={328}
                  aria-hidden={image['aria-hidden']}
                />
              </div>
            )}
            {segregatedContent && (
              <BodyM
                className="content__secondPart"
                light={lightText}
                tag="div"
                html={segregatedContent.secondPart}
              />
            )}
          </>
        )}
      </MediaWrapper>
    </Container>
  )
}
export default MediaWithBackgroundBlock
